<template>
    <div class="menu-lateral-container">
        <div class="nome-evento-header">
            <div class="evento-titulo">Nome do Evento</div>
            <div class="evento-nome">{{ nomeDoEvento }}</div>
        </div>

        <div class="menu-conteudo-container">
            <TabView class="tab-container">
                <TabPanel v-for="tab in tabs" :key="tab.header" :header="tab.header">
                    <draggable
                        :list="tab.list"
                        :group="{ name: 'elementosPagina', pull: 'clone', put: false }"
                        :sort="false"
                        :clone="criarNovoComponente"
                        item-key="id"
                        class="lista-elementos"
                        filter=".item-desativado"
                    >
                        <template #item="{ element }">
                            <div :class="{ 'item-desativado': isComponenteDesativado(element.componente) }">
                                <BotaoArrastavel :componente="element" />
                            </div>
                        </template>
                    </draggable>
                    <slot name="after" />
                </TabPanel>
            </TabView>
            <div class="aviso-arraste">
                <span>Arraste os elementos para a página e solte</span>
                <i class="material-symbols-outlined">swipe_right</i>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, defineProps } from 'vue';
import BotaoArrastavel from '@/components/editorLandingPage/ui/BotaoArrastavel.vue';
import draggable from 'vuedraggable';
import { useEditorLandingPage } from '@/composables/useEditorLandingPage';
import { useRoute } from 'vue-router';

const { carregarDadosEvento, criarNovoComponente, nomeDoEvento, temFormulario } = useEditorLandingPage();

const isComponenteDesativado = (nomeComponente) => {
    if (nomeComponente === 'formulario' && temFormulario.value) {
        return true;
    }

    return false;
};

const route = useRoute();

defineProps({
    tabs: {
        type: Array,
        required: true,
    },
});

onMounted(async () => {
    const eventoId = route.params.eventoId;
    await carregarDadosEvento(eventoId);
});
</script>

<style scoped lang="scss">
::v-deep .p-tabview {
    .p-tabview-nav {
        display: flex;
        justify-content: flex-end;
        li {
            flex: 1;
            .p-tabview-nav-link {
                display: block;
                text-align: center;
            }
        }
    }
}

.menu-lateral-container {
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    flex-shrink: 0;
    height: 100%;
}

.menu-conteudo-container {
    display: flex;
    flex-direction: column;
    justify-content: space-betweenpa;
    height: 100%;
}

:deep(.p-tabview .p-tabview-nav) {
    border: none;
    border-bottom: 1px solid #e0e0e0;
    background-color: transparent;
}

:deep(.p-tabview .p-tabview-nav li .p-tabview-nav-link) {
    background-color: transparent;
    border: none;
    color: #666;
}

:deep(.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link) {
    color: #0f97c7;
    border-bottom: 2px solid #0f97c7;
    background-color: transparent;
}

.tab-container {
    flex: 1;
    display: flex;
    flex-direction: column;
}

:deep(.p-tabview-panels) {
    position: relative;
    flex-grow: 1;
    overflow-y: auto;
}

:deep(.p-tabview-panel) {
    position: absolute;
    left: 12px;
    bottom: 12px;
    right: 12px;
    top: 12px;
}

.nome-evento-header {
    background-color: white;
    padding: 12px 16px;
}

.evento-titulo {
    font-size: 12px;
    color: #666;
    margin-bottom: 4px;
}

.evento-nome {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    line-height: 1.3;
}

.p-tabview-panels {
    background-color: red;
    height: 100%;
    overflow-y: auto;
}

.header-secao {
    text-align: center;
    color: #0f97c7;
    font-weight: 600;
    font-size: 14px;
    padding: 16px 16px 12px 16px;
    border-bottom: 2px solid #0f97c7;
    margin-bottom: 16px;
}

.lista-elementos {
    display: flex;
    flex-direction: column;
}
.aviso-arraste {
    padding: 16px;
    font-size: 14px;
    font-weight: 500;
    color: #0f97c7;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    background-color: white;
    margin-top: auto;
    border-top: 1px solid #e0e0e0;
}

.material-symbols-outlined {
    font-size: 18px;
}

.item-desativado {
    opacity: 0.5;
    cursor: not-allowed;
}
.item-desativado .botao-arrastavel {
    pointer-events: none;
}
</style>
